/* eslint-disable react-hooks/exhaustive-deps */

import loadLeft from "@/assets/load_left.png";
import loadRight from "@/assets/load_right.png";
import noSecKill from "@/assets/no_seckill.png";
import loadingPng from "@/base64";
import { platform } from "@/utils/platform";
import { getUrlParam } from "@/utils/url-parse";
import { Image, InfiniteScroll } from "antd-mobile";
import { isEmpty } from "lodash";
import { inject, observer } from "mobx-react";
import React, { useCallback, useEffect, useRef, useState } from "react";
import { pxtorem } from "../../../../utils/pxtorem";
import ActivityCom from "../../../activity/Index";
import ProductCom from "../../../product/Index";
import { useDataHook } from "./hooks/useDataHook";
import styles from "./index.module.less";
import { Props } from "./types/index";


const HorizontalNavigation: React.FC<Props> = ({
  appStore,
  cpntData,
  pageData,
  resourceRank,
  last=false,
  sticky,
  stickTop,
}) => {
  const {
    tabOptps,
    setTabOptps,
    activeTab1Index,
    activeTab1,
    activeTab2Index,
    activeTab2,
    hasMore,
    isAllEmpty,
    setIsAllEmpty,
    lockRef,
    fromIndex,
    changeActiveKey,
    changeActiveChildKey,
    loadMore,
    queryActivity,
    queryProduct,
    loadMoreActivity,
    loadMoreProduct,
    changeTime,
} = useDataHook({
    cpntData,
    pageData,
    last,
  });

  //加载更多(仅限最后一个组件为档期或商品)
  const InfiniteScrollContent = ({ hasMore }: { hasMore?: boolean; }) => {
    if (!last) {
      return <></>;
    }
    return (
      <>
        {hasMore ? (
          <div className={styles.loadingMore}>
            <Image src={loadingPng} width={pxtorem(20)} height={pxtorem(20)}></Image>
          </div>
        ) : (
          <div style={{ display: "flex", alignItems: "center" }}>
            <Image style={{ width: pxtorem(26), height: pxtorem(2) }} src={loadLeft}></Image>
            <div style={{ color: "rgba(204, 204, 204, 1)" }}>已经到底了</div>
            <Image style={{ width: pxtorem(26), height: pxtorem(2) }} src={loadRight}></Image>
          </div>
        )}
      </>
    );
  };

  const getTabContent = () => {
    if(!activeTab2){
      console.error("getTabContent为空，activeTab2是null", activeTab2);
      return null;
    }
    // 档期
    if(activeTab2?.type=== "ACTIVITY") {
      if(isEmpty(activeTab2?.dataInfo?.result)){
        return (
          <div className={styles.nullStatus}>
            <Image className={styles.noSecKill} src={noSecKill}></Image>
            <div className={styles.text}>暂无活动</div>
          </div>
        );
      }
      return (
        <div
          style={{
            padding: `${pxtorem(6)}`,
          }}>
          <ActivityCom
            propData={activeTab2}
            pageData={pageData}
            last={last}
            loadMore={loadMoreActivity}
            isNav={true}
            navType="normal"
            navResourceRank={resourceRank}></ActivityCom>
        </div>
      );
    }

    // 商品
    if(activeTab2?.type=== "PRODUCT") {
      if(isEmpty(activeTab2?.dataInfo?.result)){
        return (
          <div className={styles.nullStatus}>
            <Image className={styles.noSecKill} src={noSecKill}></Image>
            <div className={styles.text}>暂无商品</div>
          </div>
        );
      }
      return (
        <div
          style={{
            paddingLeft: `${pxtorem(12)}`,
            paddingRight: `${pxtorem(12)}`,
            paddingTop: `${pxtorem(6)}`,
          }}>
          <ProductCom
            propData={activeTab2}
            pageData={pageData}
            isNav={true}
            last={last}
            navType="normal"
            navStyle="HORIZONTAL"
            navResourceRank={resourceRank}
            loadMore={ loadMoreProduct}></ProductCom>
        </div>
      );
    }

  };

  // 初始化组件数据
  useEffect(() => {
    try {
      if(!cpntData){
        return;
      }
      const cpntDataCopy = JSON.parse(JSON.stringify(cpntData));
      setTabOptps(cpntDataCopy);
    } catch (error) {
      console.error("ch横向导航失败", error);
    }
  }, [cpntData]);

  // 监听tab内容参数，加载数据
  useEffect(() => {
    try {
      if(!pageData || !activeTab1 || !activeTab2){
        return;
      }
      if (activeTab2.type === "ACTIVITY") {
        queryActivity();
      } else if (activeTab2.type === "PRODUCT") {
        queryProduct();
      }
    } catch (error) {
      console.error("查询横向导航失败", error);
    }
  }, [activeTab1Index,activeTab2Index]);//这里不监听fromIndex，而是加载更多时，手动调queryActivity或queryProduct


  // 判断是否没有任何导航tabs数据
  useEffect(() => {
    if (tabOptps && !tabOptps?.navigationConfigDetails?.length) {
      setIsAllEmpty(true);
    }
  }, [tabOptps]);

  // sticky固定的高度
  const stickTopLast=stickTop ? pxtorem(stickTop) :((platform.isH5 || platform.isWxH5) ? pxtorem(44) : pxtorem(0));
  return (
    <>
      <div
        className="navigation_horizontal_wrapper"
        style={{
          marginTop: !isAllEmpty ? pxtorem(cpntData?.paddingTop || 0) : "",
          marginBottom: !isAllEmpty ? pxtorem(cpntData?.paddingBottom || 0) : "",
        }}
        id={cpntData?.componentCode}>
        <div className={styles.tabsBox} 
            style={{
              top: stickTopLast,
              background: cpntData?.backgroundImgUrl ? `url(${cpntData.backgroundImgUrl}) no-repeat` : "unset",
              backgroundSize: "cover",
              backgroundColor: cpntData?.backgroundColor,
            }}>
          {/* 一级tabs */}
          <div
            className={styles.tabs1Box}
            id={`${activeTab1.componentDetailCode}-nav`}>
            {tabOptps?.navigationConfigDetails?.map((nav, index) => {
              return (
                <div key={index}>
                  <div
                    style={{
                      paddingRight: index < tabOptps?.navigationConfigDetails?.length ? pxtorem(18) : 0,
                      color: index === activeTab1Index ? cpntData?.activeFontColor : cpntData?.fontColor,
                      backgroundColor: index === activeTab1Index ? cpntData?.activeBackgroundColor : "",
                    }}
                    className={index === activeTab1Index ? styles.active_tab : styles.normal_tab}
                    id={`${cpntData?.componentCode}-nav${index}`}
                    data-param={JSON.stringify({
                      type: "普通导航",
                      name: document.title,
                      tab_name: nav.tabName,
                      rank: index,
                      market_id: getUrlParam()?.["customPageCode"],
                      market_name: document.title,
                    })}
                    data-eventid={(cpntData?.componentCode || "") + "-nav" + index}
                    onClick={() => changeActiveKey(index)}>
                    {nav.tabImage ? (
                      <Image
                        className={index === activeTab1Index ? styles.active_img : styles.normal_img}
                        src={nav.tabImage}
                        fit="cover"></Image>
                    ) : (
                      <div className={styles.nav_text}>{nav.tabName}</div>
                    )}
                    {index === activeTab1Index && (
                      <div className={styles.nav_content}>
                        <div className={styles.nav_dot} style={{
                            backgroundColor: cpntData?.activeColor,
                          }}></div>
                      </div>
                    )}
                  </div>
                </div>
              );
            })}
          </div>
          
          {/* 二级tab */}
          {activeTab1?.childNavigationConfigDetails && 
          activeTab1?.childNavigationConfigDetails.length > 0 && (
            <div className={styles.tabs1Box}>
              {activeTab1?.childNavigationConfigDetails.map((childNav, childIndex) => {
                const isActive = childIndex === activeTab2Index; // 基于索引判断是否激活
                return (
                  <div
                    key={childIndex}
                    className={isActive ? styles.active_tab : styles.normal_tab}
                    style={{
                      paddingRight: activeTab1Index < tabOptps?.navigationConfigDetails?.length ? pxtorem(18) : 0,
                      color: isActive ? cpntData?.activeFontColor : cpntData?.fontColor,
                      backgroundColor: isActive ? cpntData?.activeBackgroundColor : "",
                    }}
                    onClick={() => changeActiveChildKey(childIndex)}>
                    {childNav.tabImage ? (
                      <Image
                        className={isActive ? styles.active_img : styles.normal_img}
                        src={childNav.tabImage}
                        fit="cover" />
                    ) : (
                      <div className={styles.nav_text}>{childNav.tabName}</div>
                    )}
                    {isActive && (
                      <div className={styles.nav_content}>
                        <div
                          className={styles.nav_dot}
                          style={{
                            backgroundColor: cpntData?.activeColor,
                          }} />
                      </div>
                    )}
                  </div>
                );
              })}
            </div>
          )}
        </div>
        

        {/* 档期或商品内容 */}
        <div
          key={activeTab1.componentDetailCode}
          id={`${activeTab1.componentDetailCode}-content`}>
          {getTabContent()}
        </div>
      </div>

      {/* 下滑加载更多，加载时有loading效果 */}
      {activeTab2.dataInfo?.result?.length > 0 && hasMore && (
        <InfiniteScroll loadMore={loadMore} hasMore={hasMore}>
          <InfiniteScrollContent hasMore={hasMore} />
        </InfiniteScroll>
      )}
    </>
  );
};

export default inject("appStore")(observer(HorizontalNavigation));
